module.exports = __webpack_public_path__ + "static/agro-desktop-fd1293e2bdb1ba7232275ee3269e24cb.png";